export default __webpack_public_path__ + "static/media/idex.d42efe76.svg";